<template>
  <div class="col-span-1 space-y-4 md:col-span-3">
    <div class="w-full divide-y divide-ontick-steel-500 rounded bg-ontick-graphite-500 p-4 shadow">
      <div class="flex flex-col gap-4 pb-4">
        <div class="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div class="flex items-end gap-2">
              <h3 class="text-lg font-bold sm:text-2xl">
                {{ checkoutData.extension_name }}
              </h3>
              <span class="text-xs font-semibold leading-loose">
                {{ checkoutData.extension_plan_name }}
              </span>
            </div>
            <!-- <p class="text-xs text-gray-500 dark:text-gray-400">
              Desenvolvedor: {{ checkoutData.extension_owner }}
            </p> -->
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ frequency.relative.charAt(0).toUpperCase() + frequency.relative.slice(1) || "Mensal" }}
            </p>
          </div>
          <div class="flex flex-col gap-1 text-gray-400 sm:items-end">
            <div class="flex flex-col gap-1 sm:items-end" v-if="checkoutData.coupon_data">
              <span class="text-xs">
                Valor original:
                <span class="line-through">
                  {{ checkoutData.extension_original_price | currency }}
                </span>
              </span>

              <span class="text-xs">
                Cupom aplicado:
                <span class="">
                  {{ checkoutData.coupon_data.coupon_off_price | currency }}
                </span>
              </span>
            </div>
            <button v-else class="text-xs font-bold uppercase text-ontick-blue-600" @click="openCouponModal">
              Inserir cupom
            </button>
            <div class="flex gap-2">
              <span> Total: </span>
              <div>
                <span class="font-bold text-gray-300">
                  {{
                    `${
                      checkoutData.coupon_data
                        ? checkoutData.extension_adjusted_price
                        : checkoutData.extension_original_price
                    }` | currency
                  }}
                </span>
                <span> /{{ frequency.full }} </span>
              </div>
            </div>
          </div>
          <!-- <div class="flex gap-2 text-gray-400" v-else>
            <span> Total: </span>
            <div>
              <span class="font-bold text-gray-300">
                R${{ checkoutData.extension_original_price }}
              </span>
              <span> /mês </span>
            </div>
          </div> -->
        </div>
        <p class="text-xs text-gray-400">
          {{ checkoutData.extension_plan_desc }}
        </p>
      </div>
      <div class="flex flex-col gap-4 pt-4">
        <h4 class="font-bold">Incluso nesta assinatura:</h4>
        <ul class="grid list-disc grid-cols-1 gap-4 pl-6 text-xs sm:grid-cols-2">
          <li
            class="text-ontick-blue-600"
            v-for="(feature, index) in checkoutData.extension_features.features"
            :key="index"
          >
            <p class="text-gray-300">{{ feature }}</p>
          </li>
        </ul>

        <div id="grecaptcha" class="hidden"></div>

        <button
          :disabled="buttonDisabled"
          @click="$emit('validateData')"
          class="flex h-10 w-full items-center justify-center gap-2 rounded bg-ontick-green-600 py-2 text-sm font-bold text-ontick-carbon-900 shadow filter transition-all ease-in-out hover:brightness-125 disabled:hidden"
        >
          <transition name="fade" mode="out-in">
            <div key="1" v-if="loadingInvoice">
              <i v-html="$icons.loading"></i>
              <span class="sr-only"> Carregando </span>
            </div>
            <div key="2" v-else class="flex items-center gap-2">
              <i v-html="$icons.open_in_new"></i>
              <span> Ir para pagamento </span>
            </div>
          </transition>
        </button>
      </div>
    </div>
    <div class="flex w-full flex-col gap-1 text-xs">
      <h4 class="text-xs font-bold">Segurança</h4>
      <p class="inline text-gray-400">
        Nossos pagamentos são gerenciados por
        <span class="inline-flex"> <i v-html="$icons.iugu" class="text-gray-300"></i> </span>. Para saber mais, leia os
        <a
          href="https://ajuda.ontick.com.br/support/solutions/articles/151000074574-termos-de-uso"
          target="blank"
          class="text-ontick-blue-600 underline"
        >
          Termos de Uso
        </a>
        do nosso gateway de pagamentos.
      </p>
    </div>
    <portal to="modal">
      <ontick-modal-component :open="couponModalIsActive" @close="couponModalIsActive = false" size="small">
        <div class="mx-auto flex flex-col items-center gap-4 sm:w-1/2">
          <h3 class="font-bold sm:text-lg">Inserir cupom</h3>
          <div class="flex w-full flex-col gap-1">
            <input
              type="text"
              :value="couponCode"
              @input="couponCode = $event.target.value.toUpperCase()"
              name="coupon"
              maxlength="6"
              v-mask="'NNNNNN'"
              class="focus:outline-none h-10 w-full rounded border-0 bg-ontick-carbon-500 text-center text-sm shadow"
              :class="
                errors.first('coupon')
                  ? 'ring-2 ring-ontick-red-600 focus:ring-2 focus:ring-ontick-red-600'
                  : ' focus:ring-2 focus:ring-ontick-blue-600'
              "
              v-validate="'required|length:6'"
              :error="errors.first('coupon')"
            />
            <span v-if="errors.first('coupon')" class="text-center text-xs text-ontick-red-600">
              {{ errors.first("coupon") }}
            </span>
          </div>
          <ontick-button class="w-full" @click.native="checkCoupon"> Confirmar </ontick-button>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
import axios from "axios";
import { Encrypt } from "../../../shared/utils/encrypt";
import { v4 } from "uuid";
import event_bus from "../../../shared/utils/event_bus";

export default {
  components: { OntickModalComponent },

  props: {
    checkoutData: {
      type: Object,
    },
    loadingInvoice: {
      type: Boolean,
    },
    buttonDisabled: {
      type: Boolean,
    },
  },

  data() {
    return {
      couponModalIsActive: false,
      couponCode: "",
    };
  },

  computed: {
    frequency() {
      switch (this.checkoutData.billing_frequency) {
        case "MONTH":
          return {
            full: "mês",
            relative: "mensal",
          };
        case "2_MONTH":
          return {
            full: "bimestre",
            relative: "bimestral",
          };
        case "3_MONTH":
          return {
            full: "trimestre",
            relative: "trimestral",
          };
        case "6_MONTH":
          return {
            full: "semestre",
            relative: "semestral",
          };
        case "YEAR":
          return {
            full: "ano",
            relative: "anual",
          };
        default:
          return {
            full: "mês",
            relative: "mensal",
          };
      }
    },
  },

  methods: {
    openCouponModal() {
      this.couponModalIsActive = true;
    },
    checkCoupon() {
      this.$validator.validate().then((isValid) => {
        if (isValid) {
          let uuidv4 = v4();

          let uuidKey = "".padStart(32, uuidv4.slice(0, 4));
          // let checkoutKey = "".padStart(
          //   32,
          //   this.$route.params.checkout_code.slice(0, 4)
          // );

          let payload = {
            checkout_code: this.$route.params.checkout_code,
            coupon_code: this.couponCode,
          };

          // console.log(payload);

          let body = {
            uuidv4,
            p: Encrypt(JSON.stringify(payload), uuidKey),
          };

          let config = {
            headers: {
              authorization: uuidv4,
            },
            params: {
              hash: Encrypt(uuidv4, uuidKey),
            },
          };
          axios
            .post(this.$endpoint.CHECK_COUPON, body, config)
            .then((res) => {
              event_bus.$emit("addCoupon", {
                ...res.data,
                coupon: this.couponCode,
              });
              this.$swal("Cupom aplicado", `Cupom ${this.couponCode} aplicado com sucesso`, "success");
            })
            .catch((err) => {
              console.error(err);
              this.$swal("Erro", "Cupom inválido", "error");
              this.couponCode = "";
            })
            .finally(() => {
              this.couponModalIsActive = false;
            });
        }
      });
    },
  },

  watch: {
    couponCode: {
      handler() {
        this.$validator.validate();
      },
    },
  },
};
</script>

<style scoped lang="scss">
.fade {
  &-enter,
  &-leave-to {
    @apply scale-125 opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
